import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=a58bb480&scoped=true"
import script from "./TrendChart.vue?vue&type=script&lang=ts"
export * from "./TrendChart.vue?vue&type=script&lang=ts"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=a58bb480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58bb480",
  null
  
)

export default component.exports